export const selectDefaultBuilding = (state) => state.buildings.defaultBuilding;